import React from "react";
import Faqs from "../../views/adminView/faqs";

export default function AdminFaqs() {
    return <Faqs />
}